// On phones, tables with a single header row become labelled cards (see .table-cards-mobile in assets/new/style.css).
// Vue re-renders rows often, so labels are re-applied after DOM changes.
const MOBILE_QUERY = '(max-width: 767.98px)'

const labelTable = (table) => {
    const headRows = table.querySelectorAll('thead tr')
    if (headRows.length !== 1 || table.classList.contains('table-no-cards')) {
        return
    }

    const labels = Array.from(headRows[0].children).map(cell => cell.textContent.trim())
    if (labels.length < 2) {
        return
    }

    table.classList.add('table-cards-mobile')
    table.querySelectorAll('tbody tr').forEach(row => {
        Array.from(row.children).forEach((cell, index) => {
            if (cell.colSpan === 1 && labels[index]) {
                cell.setAttribute('data-label', labels[index])
            }
        })
    })
}

export default function initMobileTables() {
    const query = window.matchMedia(MOBILE_QUERY)
    let timer = null

    const run = () => {
        timer = null
        document.querySelectorAll('table').forEach(labelTable)
    }

    const schedule = () => {
        if (!query.matches || timer) {
            return
        }
        timer = setTimeout(run, 150)
    }

    new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true})
    schedule()
}
